// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#martan-quickview{padding:0!important}#martan-quickview .modal-dialog{margin:0 auto}.mt-quickview .review-card{margin-top:0!important;width:100%!important}.mt-quickview .review-card__images{display:none}", ""]);
// Exports
module.exports = exports;
